export default class AtvInteracoesService {
    constructor(UIService, AtvAtivo, AtvInteracao) {
        this.UI = UIService;
        this.AtvAtivo = AtvAtivo;
        this.AtvInteracao = AtvInteracao;
    }
}
AtvInteracoesService.$inject = ['UIService', 'AtvAtivo', 'AtvInteracao'];
